import { useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, Bell } from 'lucide-react'

export function CTAAlertas() {
  const [email, setEmail] = useState('')
  const [interessado, setInteressado] = useState(false)

  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  return (
    <section id="entrar" className="bg-ink text-bone py-16 md:py-24">
      <div className="container-editorial max-w-5xl">
        <div className="grid md:grid-cols-[1fr_1.2fr] gap-10 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-3 mb-5">
              <Bell className="w-4 h-4 text-taupe" strokeWidth={1.5} />
              <span className="text-xs tracking-[0.35em] uppercase text-bone/60">
                Lista de interesse
              </span>
            </div>
            <h2 className="font-display font-light text-3xl md:text-5xl leading-[1.05] tracking-tighter text-bone">
              Alertas por e-mail <em className="text-taupe">em breve</em>.
            </h2>
            <p className="mt-5 text-base text-bone/65 leading-relaxed max-w-md">
              Deixe seu e-mail para saber quando começarmos. Prometemos não spammar —
              só uma mensagem quando virar real.
            </p>
          </motion.div>

          <motion.form
            onSubmit={(e) => {
              e.preventDefault()
              if (validEmail) {
                setInteressado(true)
                setEmail('')
                setTimeout(() => setInteressado(false), 6000)
              }
            }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="flex flex-col gap-3"
          >
            <label htmlFor="email-alerta" className="sr-only">
              Seu e-mail
            </label>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                id="email-alerta"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="flex-1 px-6 py-4 rounded-full bg-bone text-ink placeholder:text-taupe focus:outline-none focus:ring-2 focus:ring-bone/50 text-base"
              />
              <button
                type="submit"
                disabled={!validEmail && email.length > 0}
                className="inline-flex items-center justify-center gap-2 bg-terracotta text-bone px-6 py-4 rounded-full hover:bg-terracotta/85 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm tracking-wide group whitespace-nowrap"
              >
                {interessado ? 'Anotado — te avisamos' : 'Quero saber quando lançar'}
                {!interessado && <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />}
              </button>
            </div>
            <p className="text-xs text-bone/45 pl-2 leading-relaxed">
              Estamos em fase de construção. Esta lista é apenas para avisar quando
              o serviço de alertas diários estiver disponível. Nenhum dado é usado
              para outra coisa.
            </p>
          </motion.form>
        </div>
      </div>
    </section>
  )
}
